<template>
    <div>
        <div class="operas">
            <div class="opera operas-tit">
                操作
            </div>
            <div class="opera" @click="reply()">
                回复
            </div>
            <div class="opera" @click="copy()">
                复制该评论
            </div>
            <div class="opera" @click="cancel()">
                取消
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        show:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return {

        }
    },
    methods:{
        reply(){
            this.$emit('reply');
        },
        copy(){
            this.$emit('copy');
        },
        jb(){
            this.$emit('jb');
        },
        cancel(){
            this.$emit('cancel');
        }
    }
}
</script>
<style lang="scss" scoped>
.operas{
    background-color: #fff;
    font-size: 15px;
    width: 280px;
    border-radius: 30px;
}
.operas-tit{
    font-size: 17px;
    font-weight: bold;
}
.opera{
    padding: 14px;
    border-bottom: 1px solid #ededed;
}
.opera:last-child{
    border-bottom:0;
}

</style>
